import {authActionTypes} from "./actionTypes";

export function setLogin(payload) {
    return {
        type: authActionTypes.SET_LOGIN,
        payload: payload
    }
}

export function setLogout() {
    return {
        type: authActionTypes.SET_LOGOUT,
        payload: null
    }
}

export function setVerifyName(payload) {
    return {
        type: authActionTypes.SET_VERIFY_NAME,
        payload: payload
    }
}

export function setVerifyToken(payload) {
    return {
        type: authActionTypes.SET_VERIFY_TOKEN,
        payload: payload
    }
}

export function clearVerify() {
    return {
        type: authActionTypes.CLEAR_VERIFY,
        payload: null
    }
}